// extracted by mini-css-extract-plugin
export default {"header":"New_header__rWaUP","buttonsRight":"New_buttonsRight__xs7ma","buttonUSD":"New_buttonUSD__0n6tl","pageContent":"New_pageContent__Hll4j"};